import React, { Component } from 'react';
import axios from 'axios';
import { Switch, withRouter, Route, Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

import NotFound from './components/NotFound';
import Home from './Home';
import About from './About';
import Question from './Question';
import Form from './Form';
import Results from './Results';
import TextPage from './TextPage';
import Burger from './components/Burger';
import Menu from './components/Menu';
import Overlay from './components/Overlay';

import logo from './images/logo.png';
import whiteLogo from './images/logo-white.png';
import ogImage from './images/home-1.jpg';
import { getCategories } from './categories';



class App extends Component {
    constructor() {
        super();
        this.toggleMenu = this.toggleMenu.bind(this);
        this.changePage = this.changePage.bind(this);
        this.setWhiteLogo = this.setWhiteLogo.bind(this);
    }
    
    state = {
        isMenuOpen: false,
        hasWhiteLogo: false,
        isLoading: false,
        soc: null,
        jobTitle: null,
        unionMember: null,
        remoteWorker: null,
        categories: null,
        isQuizComplete: false
    };

    async componentDidMount() {
        // animate page on load
        setTimeout(() => {
            const wrap = document.getElementById('PageWrap');
		    wrap.classList.add('__active');
        }, 1000);
        
        // Populate categories
        this.getCategories();
    }

    componentWillReceiveProps(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.changePage();
        }
    }

    setWhiteLogo(option) {
        setTimeout(() => {
            this.setState({
                hasWhiteLogo: option
            });
        }, 100);
    }

    async getCategories() {
        const localStorageState = localStorage.getItem('state');
        if (localStorageState) {
            this.setState(JSON.parse(localStorageState))
        } else {
            const questionPostsData = await axios.get(process.env.CMS_URL + '/wp-json/wp/v2/question?acf_format=standard');
            const categories = await getCategories(questionPostsData);

            this.setState({
                categories
            });
        }
    }

    setSoc = (soc, jobTitle) => {
        this.setState({
            soc,
            jobTitle
        }, () => {
            this.updateLocalStorage();
        });
    }

    setUnion = (unionMember) => {
        this.setState({
            unionMember
        }, () => {
            this.updateLocalStorage();
        })
    }

    setRemoteWorker( option ) {
        this.setState({
            remoteWorker: option
        }, () => {
            this.updateLocalStorage();
        })
    }

    getCategoryData = (categoryID) => {
        const { categories } = this.state; 
        
        const requestedCategory = categories.find(category => category.category.id == categoryID);
        return requestedCategory;
    }

    updateCategoryQuestion = (categoryID, questionIndex, answer, score) => {
        const { categories } = this.state;
        
        const updatedCategories = categories.map((category) => {
            if (category.category.id == categoryID) {
                // Dynamic categories only change their conditional sub-question
                // when the first answer is toggled.
                if (category.dynamic && questionIndex == 0) {
                    if (answer == 0) {
                        category.subQuestions[1].score = null;
                        category.subQuestions[1].answer = null;
                        category.score = null;
                    } else {
                        category.subQuestions[1].score = 0;
                        category.subQuestions[1].answer = 0;
                    }
                }

                category.subQuestions[questionIndex].answer = answer;
                category.subQuestions[questionIndex].score = score;

                if (category.subQuestions.every(question => question.score != null)) {
                    // every question has been answered
                    const totalScore = category.subQuestions.reduce((acc, curr) => {
                        if (curr.id != 3) {
                            return acc + curr.score;
                        } else {
                            return acc;
                        }
                    }, 0);
                    const calculatedScore = totalScore * (100/category.total); 
                    category.score = Math.floor(calculatedScore);
                }

                return category;
            } 
            return category;
        });
        
        const isQuizComplete = categories.every(cat => cat.subQuestions.every(sub => sub.answer != null));

        this.setState({
            categories: updatedCategories,
            isQuizComplete
        }, () => {
            this.updateLocalStorage();
        }); 
    }

    updateLocalStorage() {
        localStorage.setItem('state', JSON.stringify(this.state));
    }    
    
    changePage() {
        const wrap = document.getElementById('PageWrap');
        wrap.className = 'pagewrap';
        
        this.setState({
            isMenuOpen: false,
            isLoading: true
        });

        setTimeout(() => {
            this.setState({
                isLoading: false
            });
        }, 900);

        setTimeout(() => {
            wrap.className = 'pagewrap __active';
        }, 1110);
    }

    toggleMenu() {
        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }

    render() {
		const { isMenuOpen, hasWhiteLogo, isLoading, categories, soc, jobTitle, unionMember, isQuizComplete } = this.state;
        console.log(this.state);
        return (
            <React.Fragment>
                <MetaTags>
                    <title>How Good Is Your Job | Take the Quiz</title>
                    <meta name="description" content="Take our careers quiz today to find out how your job compares to others in your industry. See how you score on job intensity, worker voice and job security." />
                    <meta property="og:title" content="How Good Is Your Job | Take the Quiz" />
                    <meta property="og:img" content={ogImage} />
                    <meta name="facebook-domain-verification" content="exzfplpng9p5eyfwyvb56dosapmx8e" /> 
                </MetaTags>

                {isLoading && (
                    <div className="transition" />
                )}
                <Link to="/" className='logo'>
                    <img src={hasWhiteLogo ? whiteLogo : logo} alt="Cardiff University Logo" />
                    <span className="sr-only">Cardiff University: How Good is my Job Quiz.</span>
                </Link>

                <Overlay />
                <Burger isMenuOpen={isMenuOpen} toggleMenu={this.toggleMenu} />
                <Menu isMenuOpen={isMenuOpen} />

                <Switch>
                    <Route
                        exact
                        path="/"
                        render={() => <Home setWhiteLogo={this.setWhiteLogo} />}
                    />
                    {!isLoading && (
                        <Route
                            exact
                            path="/about"
                            render={() => <About setWhiteLogo={this.setWhiteLogo} />}
                        />
                    )}

                    {!isLoading && categories && (
                        <Route
                            exact
                            path="/question/:id"
                            render={(state) => {
                                const id = parseInt(state.location.pathname.split('/')[2]);
                                if (id && (id < 12)) {
                                    return ( 
                                        <Question {...state} isQuizComplete={isQuizComplete} jobTitle={jobTitle} soc={soc} setSoc={this.setSoc} getCategoryData={this.getCategoryData} updateCategoryQuestion={this.updateCategoryQuestion} categories={categories} setWhiteLogo={this.setWhiteLogo} /> 
                                    );
                                }

                                return (<Route render={() => <NotFound setWhiteLogo={this.setWhiteLogo} />} />);

                            }}
                        />
                    )}

                    {!isLoading && categories && (
                        <Route
                            exact
                            path="/form"
                            render={(state) => <Form categories={categories} soc={soc} jobTitle={jobTitle} unionMember={unionMember} setUnion={this.setUnion} setWhiteLogo={this.setWhiteLogo} />}
                        />
                    )}      

                    {!isLoading && categories && (
                        <Route
                            exact
                            path="/results"
                            render={(state) => <Results categories={categories} soc={soc} setWhiteLogo={this.setWhiteLogo} />}
                        />
                    )}

                    {!isLoading && (
                        <Route
                            exact
                            path="/how-its-calculated"
                            render={() => <TextPage pageID="114" setWhiteLogo={this.setWhiteLogo} backButton={true} />}
                        />
                    )}

                    {!isLoading && (
                        <Route
                            exact
                            path="/interesting-facts"
                            render={() => <TextPage pageID="194" setWhiteLogo={this.setWhiteLogo} />}
                        />
                    )}

                    {!isLoading && (
                        <Route 
                            exact
                            path="/cookie-policy"
                            render={() => <TextPage pageID="94719" setWhiteLogo={this.setWhiteLogo} />}
                        />
                    )}

                    {!isLoading && (
                        <Route render={() => <NotFound setWhiteLogo={this.setWhiteLogo} />} />
                    )}
                </Switch>
            </React.Fragment>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js